module.exports = __webpack_public_path__ + "img/camera-back.e8ea7f1a.svg";